/* tslint:disable */
/* eslint-disable */
/**
 * RoadFootage.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
/**
 * Check if a given object implements the ExtendBountyRequest interface.
 */
export function instanceOfExtendBountyRequest(value) {
    let isInstance = true;
    return isInstance;
}
export function ExtendBountyRequestFromJSON(json) {
    return ExtendBountyRequestFromJSONTyped(json, false);
}
export function ExtendBountyRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'newExpiresAt': !exists(json, 'newExpiresAt') ? undefined : (new Date(json['newExpiresAt'])),
        'notifyPoster': !exists(json, 'notifyPoster') ? undefined : json['notifyPoster'],
    };
}
export function ExtendBountyRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'newExpiresAt': value.newExpiresAt === undefined ? undefined : (value.newExpiresAt.toISOString()),
        'notifyPoster': value.notifyPoster,
    };
}
